export const RECOMMEND_TO_FREE_STATSIG_EXPERIMENT = 'confluence_recommend_trial_to_free_ab';
export const NOT_ENROLLED = 'not-enrolled';

export const ENGAGEMENT_PLATFORM_MESSAGE_ID = 'rtf_recommend_trial_to_free_modal';

export const RECOMMEND_TO_FREE_ANALYTICS_SOURCE = 'confluence_recommend_trial_to_free';

export const HAMS_PRODUCT_KEY = 'confluence.ondemand';
export const CONFLUENCE_STANDARD_OFFERING_KEY = '2eda1119-fab4-4699-ab37-ff8f12052cde';

export const FALLBACK_PRODUCT_UPGRADE_URL = '/admin/billing';
